export default ({ ...props }) => (
	<div>
		<div className="w-custom mx-auto pt-3">
			<form action="/berita">
				<div className="input-group my-4">
					<input
                        type="text"
                        name="query"
                        onChange={props.onChange}
						className="form-control"
						placeholder="Search article"
						aria-label="Search article"
					/>
					<div className="input-group-append">
						<button  className="btn" type="submit"><h6 className="text-gray icon-search"></h6></button>
					</div>
				</div>
			</form>
		</div>
        { props.param && props.param != '' ?
        <div className="text-left pt-3">
            <h6 className="d-inline text-primary">Hasil Pencarian :</h6> <i>{props.param.split("query=")[1]}</i>
        </div> : ''
        }
        <style jsx>
            {
                `
                @import './styles/jmto-custom';
                    .w-custom{
                        max-width:320px;
                    }
                    .text-left i{
                        text-decoration:underline;
                        font-weight:700;
                    }
                    .form-control{
                        border:none;
                    }
                    .input-group{
                        -webkit-box-shadow: 0px 8px 30px 0px rgba($gray,0.25);
                        -moz-box-shadow: 0px 8px 30px 0px rgba($gray,0.25);
                        box-shadow: 0px 8px 30px 0px rgba($gray,0.25);
                    }
                    .btn{
                        padding:10px;
                    }
                    .btn .icon-search{
                        position:relative;
                        top:5px;
                    }
                    .form-control::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
                        font-weight:400;
                        opacity: 1; 
                      }
                      
                      .form-control:-ms-input-placeholder { /* Internet Explorer 10-11 */
                        font-weight:400;
                      }
                      
                      .form-control::-ms-input-placeholder { /* Microsoft Edge */
                        font-weight:400;
                      }
                `
            }
        </style>
	</div>
);
